import React from "react";
import { Button } from "reactstrap";

export default function AdminFormActions({
  saving,
  submitLabel = "Kaydet",
  savingLabel = "Kaydediliyor...",
  onCancel,
  cancelLabel = "Vazgeç",
  extraActions,
}) {
  return (
    <div className="d-flex flex-wrap align-items-center">
      <Button color="primary" type="submit" disabled={saving}>
        {saving ? savingLabel : submitLabel}
      </Button>
      {onCancel ? (
        <Button color="secondary" type="button" className="ml-2" onClick={onCancel}>
          {cancelLabel}
        </Button>
      ) : null}
      {extraActions}
    </div>
  );
}
